import React from 'react';
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import {makeStyles} from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
}));

const SingleSelect = ({name, scheme, defaultValue, refs, onChange, disabled, isLabel}) => {
    const classes = useStyles();
    const { i18n } = useTranslation();
    const { t } = useTranslation();
    const currentLang = i18n.language;
    const [state, setValue] = React.useState({
        [name]: defaultValue ? (typeof defaultValue === 'number' ? Number(defaultValue) : defaultValue) : 0,
    });
    const handleChange = (e) => {
        let value = e.target.value;
        setValue({...state, [name]: typeof value === 'number' ? Number(value) : value});
        if (onChange) {
            onChange(e);
        }
    };
    const isLabelEn = currentLang === 'en' && scheme.label_en

    return (
        <React.Fragment>
            <input
                type="hidden"
                ref={input => refs[name] = input}
                value={state[name]} />
            <FormControl size="small" variant="outlined" fullWidth disabled={disabled}>
                {isLabel !== false
                    ? <InputLabel id={name} required={scheme.required === true}>
                        {isLabelEn ? scheme.label_en : scheme.label}
                    </InputLabel>
                    : null}
                <Select
                    labelId={name}
                    label={isLabel !== false ? (currentLang === 'en' && scheme.value_en ? scheme.label_en : scheme.label) : undefined}
                    value={state[name]}
                    onChange={handleChange}
                >
                    <MenuItem value={0}>{t('not_selected')}</MenuItem>
                    {scheme.type.values.map(value => {
                        return (
                            <MenuItem key={value.id} value={typeof value.id === 'number' ? Number(value.id) : value.id}>
                                {currentLang === 'en' && value.value_en ? value.value_en : value.value}
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </React.Fragment>
    );
};
export default SingleSelect;